import {InjectionToken} from '@angular/core';

export interface BusinessLogicRequirements {

}

export const BusinessRequirementsInjectionToken = new InjectionToken<BusinessLogicRequirements>('redirect Business Requirements')
